import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {initClientAccountForm} from "./form";
import {createModal} from "../../helpers/modal";
import {clearFeedbacksByName, getInputsByName} from "../../helpers/forms";
import Axios from "axios";
import {createGrid} from "../../helpers/grids/grids";
import {createCellRenderer} from "../../helpers/grids/helpers";
import {waitUntil} from "../../helpers/waitUntil";
import createElement from "../../helpers/createElement";
import {getLinkifiedPublicId, getLinkifiedText} from "../../helpers/linkifyContent";

function initClientAccountsEdit() {
	const accountForm = initClientAccountForm(document.querySelector('.client-account-form'));

	const orderAssignedToAccountGrid = document.querySelector('.order-assigned-client-account-grid');

	document.querySelector('.update-account-button').onclick = updateAccount;

	const referenceProCredentialsFields = [
		'rp_client_id',
		'rp_password',
	];

	const accioDataCredentialsFields = [
		'ad_client_account',
		'ad_client_username',
		'ad_client_password',
		'ad_client_url',
	];

	const digitalDelveCredentialsFields = [
		'dd_endpoint',
		'dd_username',
		'dd_password',
	];

	const sendLoginCredentialsFields = [
		'client_account_email',
	];

	const referenceProCredentialsModal = createModal({
		modalContainer: document.querySelector('.change-reference-pro-credentials-modal'),
		init() {
			this.modalContainer
				.querySelector('.change-reference-pro-credentials-modal-update-button')
				.addEventListener('click', updateReferenceProCredentials);
		}
	})

	const accioDataCredentialsModal = createModal({
		modalContainer: document.querySelector('.change-accio-data-credentials-modal'),
		init() {
			this.modalContainer
				.querySelector('.change-accio-data-credentials-modal-update-button')
				.addEventListener('click', updateAccioDataCredentials);
		}
	})

	const digitalDelveCredentialsModal = createModal({
		modalContainer: document.querySelector('.change-digital-delve-credentials-modal'),
		init() {
			this.modalContainer
				.querySelector('.change-digital-delve-credentials-modal-update-button')
				.addEventListener('click', updateDigitalDelveCredentials);
		}
	})

	const sendLoginCredentialsModal = createModal({
		modalContainer: document.querySelector('.send-login-credentials-modal'),
		init() {
			this.modalContainer
				.querySelector('.confirm-send-login-credentials-button')
				.addEventListener('click', sendLoginCredentials);
		}
	})

	const manageClientAccountSettingsModal = createModal({
		modalContainer: document.querySelector('.manage-client-account-settings-modal'),
	})

	const changeReferenceProCredentialsButton = document.querySelector('.change-rp-credentials-button');
	if (changeReferenceProCredentialsButton) {
		changeReferenceProCredentialsButton.addEventListener('click', () => {
			referenceProCredentialsModal.display();
		})
	}

	const changeAccioDataCredentialsButton = document.querySelector('.change-ad-credentials-button');
	if (changeAccioDataCredentialsButton) {
		changeAccioDataCredentialsButton.addEventListener('click', () => {
			accioDataCredentialsModal.display();
		})
	}

	const changeDigitalDelveCredentialsButton = document.querySelector('.change-dd-credentials-button');
	if (changeDigitalDelveCredentialsButton) {
		changeDigitalDelveCredentialsButton.addEventListener('click', () => {
			digitalDelveCredentialsModal.display();
		})
	}

	const getNewTokenButton = document.querySelector('.change-concierge-verifications-token-button')
	if (getNewTokenButton) {
		getNewTokenButton.addEventListener('click', () => {
			swalConfirm({
				title: 'This will invalidate the current API token and generate a new one that must be shared with the client'
			}).then(result => {
				if (result.isConfirmed) {
					loading();

					// noinspection JSUnresolvedVariable
					Axios.post(window['routes/admin.client-accounts.get-new-token'], {})
						.then(handleAjaxSuccess)
						.catch(handleAjaxError)
						.finally(stopLoading)
				}
			})
		})
	}

	const sendLoginCredentialsButton = document.querySelector('.send-login-credentials-button')
	if (sendLoginCredentialsButton) {
		sendLoginCredentialsButton.addEventListener('click', () => {
			sendLoginCredentialsModal.display();
		})
	}

	const manageClientAccountSettingsButton = document.querySelector('.manage-client-account-settings-button')
	if (manageClientAccountSettingsButton) {
		manageClientAccountSettingsButton.addEventListener('click', () => {
			manageClientAccountSettingsModal.display();
		})
	}

	// Init api usage grid
	createGrid('.api-usage-grid', {
			columnDefs: [
				{
					field: "action.api.name",
					headerName: 'Api',
					sortable: true,
				},
				{
					field: "action.name",
					headerName: 'Action',
					sortable: true,
				},
				{
					field: "created_at",
					headerName: 'Date',
					sortable: true,
				},
				{
					field: "completed",
					headerName: 'Processed',
					sortable: true,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const completed = params.data.completed;

						// noinspection JSUnresolvedVariable
						return `
								<span
									class="badge mono badge-${completed ? 'primary' : 'dark'}"
									title="${params.data.error_string}"
								>
									${completed ? 'Yes' : 'No'}
								</span>
						`
					})
				},
			],
			paginationPageSize: 20,
			_rowName: 'Hits',
		},
		window['routes/admin.client-accounts.api-usage.grid']
	);

	//Init Order assign grid


	// Attempt to instantiate calls grid only if required
	if (orderAssignedToAccountGrid) {
		createGrid(orderAssignedToAccountGrid, {
				columnDefs: [
					{
						field: "public_id",
						headerName: 'Order Id',
						tooltipField: 'public_id',
						cellRenderer: createCellRenderer(params => {
							const detailUrl = params.data.detailUrl
							const public_id = params.data.public_id
							return getLinkifiedPublicId({detailUrl, public_id})
						}),
					},
					{
						field: "voe_company_name",
						headerName: 'Company',
						sortable: false,
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedVariable
							const detailUrl = params.data.voeCompanyDetailUrl
							// noinspection JSUnresolvedVariable
							const name = params.data.voe_company_name
							if (detailUrl && name) {
								return getLinkifiedText(detailUrl, name)
							}
							return '<span class="text-muted">Unassigned</span>';
						})
					},
					{
						field: "status_label",
						headerName: 'Status',
						sortable: false,

					},
					{
						field: "assigned_to_full_name",
						headerName: 'Assigned To',
						sortable: false,
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedVariable
							return params.data.assigned_to_full_name ?
								params.data.assigned_to_full_name :
								createElement('<span class="text-muted">On Queue</span>');
						})
					},
				],

				rowClass: 'cursor-pointer',
				paginationPageSize: 20,
				_rowName: 'Assigned Orders',
			},
			window['routes/admin.voe-orders.assigned-account-orders.grid']
		);

	}

	/** Methods */

	function updateAccount() {
		accountForm.clearFeedbacks();

		loading();

		accountForm.submit()
			.then(response => {
				handleAjaxSuccess(response, () => {
					// Do nothing
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading);
	}


	function sendLoginCredentials() {
		const modal = sendLoginCredentialsModal.modalContainer;

		clearFeedbacksByName(modal, sendLoginCredentialsFields);

		loading();

		Axios.post(window['routes/admin.client-accounts.send-login-credentials'], getInputsByName(modal, sendLoginCredentialsFields))
			.then((response) => {
				sendLoginCredentialsModal.hide()
				// noinspection JSUnresolvedVariable
				swalConfirm({
					title: 'First Login Security Token',
					text: '',
					icon: 'warning',
					confirmButtonColor: '#3085d6',
					confirmButtonText: 'Done',
					showCancelButton: false,
					html: `
							<small class="text-danger">
								Please share the following <b>security token</b> with the client.
								<br>
								It will be requested when client account user tries to login for the first time.
							</small>
							<div class="input-group mt-3">
								<input type="text" value="${response.data.two_factor_authentication_password}" class="form-control two-factor-authentication-password" id="two-factor-authentication-password" disabled>
								<div class="input-group-append two-factor-authentication-password">
									<button class="btn btn-outline-light rounded-right px-2 copy-two-factor-authentication-password-button">
											<i class="fas fa-clipboard"></i>
									</button>
								</div>
							</div>
							`
				}).then(() => {
					window.location.reload();
				})

				// Assign event listener after SWAL popup is displayed
				waitUntil(
					() => document.querySelector('.copy-two-factor-authentication-password-button')
				).then(() => {
					document.querySelector('.copy-two-factor-authentication-password-button')
						.addEventListener('click', () => {
							const password = document.querySelector('.two-factor-authentication-password').value
							try {
								navigator.clipboard.writeText(password).then(() => {
									alert('Password copied to clipboard')
								})
							} catch (e) {
								alert('Password could not be copied to clipboard');
							}
						})
				})
			})
			.catch(e => {
				handleAjaxError(e, modal)
			})
			.finally(stopLoading);
	}


	function updateReferenceProCredentials() {
		const modal = referenceProCredentialsModal.modalContainer;

		clearFeedbacksByName(modal, referenceProCredentialsFields);
		loading();

		Axios.post(window['routes/admin.client-accounts.change-credentials.reference-pro'], getInputsByName(modal, referenceProCredentialsFields))
			.then(handleAjaxSuccess)
			.catch(e => {
				handleAjaxError(e, modal)
			})
			.finally(stopLoading);
	}

	function updateAccioDataCredentials() {
		const modal = accioDataCredentialsModal.modalContainer;

		clearFeedbacksByName(modal, accioDataCredentialsFields);
		loading();

		Axios.post(window['routes/admin.client-accounts.change-credentials.accio-data'], getInputsByName(modal, accioDataCredentialsFields))
			.then(handleAjaxSuccess)
			.catch(e => {
				handleAjaxError(e, modal)
			})
			.finally(stopLoading);
	}

	function updateDigitalDelveCredentials() {
		const modal = digitalDelveCredentialsModal.modalContainer;

		clearFeedbacksByName(modal, digitalDelveCredentialsFields);
		loading();

		Axios.post(window['routes/admin.client-accounts.change-credentials.digital-delve'], getInputsByName(modal, digitalDelveCredentialsFields))
			.then(handleAjaxSuccess)
			.catch(e => {
				handleAjaxError(e, modal)
			})
			.finally(stopLoading);
	}
}

export {initClientAccountsEdit}
